<template>
  <div class="header-wrap">
    <div class="banner" style="background-image: url(./images/bg1.png)"></div>
    <div class="navbar-wrap">
      <ul class="navbar-list clearfix">
        <li class="list pull-left" v-for="(item, index) in linkArr" :key="index" @click="getNext(index)">
          <a :class="{'active': item.act}" href="javascript:;">
            {{item.name}}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
  },
  name: "headerbox",
  data() {
    return {
      linkArr: [
        { name: '首页', url: 'home', act: true },
        { name: '规章制度', url: 'system', act: false },
        { name: '公示公告', url: 'notice', act: false },
        { name: '数据统计', url: 'javascript:;', act: false },
      ]
    };
  },
  methods: {
    ...mapActions([]),
    getNext (index) {
      for (let i = 0, len = this.linkArr.length; i < len; i++) {
        this.linkArr[i].act = false
      };
      this.linkArr[index].act = true;
      window.location.href = `#/${this.linkArr[index].url}?&linkIndex=${index}`
    }
  },
  watch: {
  },
  computed: {
    ...mapGetters([])
  },
  created() {},
  mounted() {
    function UrlSearch() {
      let name,value
      let str=location.href  //取得整个地址栏
      let num=str.indexOf("?") 
      str=str.substr(num+1) //str得到?之后的字符串

      let arr=str.split("&") //得到&分割的参数，放入数组中
      for(let i = 0; i < arr.length; i++)
      {
        num=arr[i].indexOf("=")
        if(num>0)
        {
            name=arr[i].substring(0,num)
            value=arr[i].substr(num+1)
            this[name]=value
        }
      }
    }
    let Request = new UrlSearch()
    let linkIndex = Request.linkIndex
    for (let i = 0, len = this.linkArr.length; i < len; i++) {
        this.linkArr[i].act = false
      };
      this.linkArr[linkIndex].act = true;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss">
@import "../assets/scss/variables";
@import "../assets/scss/mixins";
.header-wrap {
  position: relative;
  width: 100%;
  height: auto;
  .banner {
    width: 100%;
    height: 260px;
    background-position: center center;
  }
  .navbar-wrap {
    position: relative;
    width: 100%;
    height: auto;
    background: #0b4793;
    .navbar-list {
      width: 1200px;
      height: auto;
      margin: 0 auto;
      a {
        height: 60px;
        line-height: 60px;
        padding-left: 60px;
        padding-right: 60px;
        font-size: 20px;
        color: $white;
        cursor: pointer;
        display: block;
      }
      a.active, a:hover {
        background: #297bc3;
      }
    }
  }
}
</style>